export { ContentPage as default } from '../processes/Content/ContentPage';
export { getStaticProps } from '../processes/Content/getStaticProps';
export { getStaticPaths } from '../processes/Content/getStaticPaths';
